import React from 'react';

function SiteProgress({ totalTrips, checkedTrips, isDropdown }) {
  return (
    <div>
      {(checkedTrips > 0) && (checkedTrips !== totalTrips) && (
        <div
          className={`flex items-center justify-center ${
            isDropdown ? 'px-2' : 'px-4'
          } py-1 mb-1 border border-orange-300 rounded-lg bg-orange-100 bg-opacity-75 shadow-sm`}>
          <div className="animate-spin mr-2">
            <svg
              width={`${isDropdown ? '6' : '12'}`}
              height={`${isDropdown ? '6' : '12'}`}
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.3125 12.6875C8.3125 11.9629 7.72461 11.375 7 11.375C6.27539 11.375 5.6875 11.9629 5.6875 12.6875C5.6875 13.4121 6.27539 14 7 14C7.72461 14 8.3125 13.4121 8.3125 12.6875ZM7 2.625C6.27539 2.625 5.6875 2.03711 5.6875 1.3125C5.6875 0.587891 6.27539 0 7 0C7.72461 0 8.3125 0.587891 8.3125 1.3125C8.3125 2.03711 7.72461 2.625 7 2.625ZM12.6875 8.3125C11.9629 8.3125 11.375 7.72461 11.375 7C11.375 6.27539 11.9629 5.6875 12.6875 5.6875C13.4121 5.6875 14 6.27539 14 7C14 7.72461 13.4121 8.3125 12.6875 8.3125ZM2.625 7C2.625 7.72461 2.03711 8.3125 1.3125 8.3125C0.587891 8.3125 0 7.72461 0 7C0 6.27539 0.587891 5.6875 1.3125 5.6875C2.03711 5.6875 2.625 6.27539 2.625 7ZM2.97773 4.29023C2.25312 4.29023 1.66523 3.70234 1.66523 2.97773C1.66523 2.25313 2.25312 1.66523 2.97773 1.66523C3.70234 1.66523 4.29023 2.25313 4.29023 2.97773C4.29023 3.70234 3.70234 4.29023 2.97773 4.29023ZM11.0223 4.29023C10.2977 4.29023 9.70977 3.70234 9.70977 2.97773C9.70977 2.25313 10.2977 1.66523 11.0223 1.66523C11.7469 1.66523 12.3348 2.25313 12.3348 2.97773C12.3348 3.70234 11.7469 4.29023 11.0223 4.29023ZM2.97773 12.3348C2.25312 12.3348 1.66523 11.7469 1.66523 11.0223C1.66523 10.2977 2.25312 9.70977 2.97773 9.70977C3.70234 9.70977 4.29023 10.2977 4.29023 11.0223C4.29023 11.7469 3.70234 12.3348 2.97773 12.3348Z"
                fill="#F3986D"
              />
            </svg>
          </div>
          <span
            className={`text-orange-500 ${
              isDropdown ? 'font-light text-xs' : 'font-medium'
            }`}>
            In Progress {checkedTrips}/{totalTrips}
          </span>
        </div>
      )}
      {(checkedTrips === totalTrips) && (totalTrips != 0) && (
        <div
          className={`flex items-center justify-center ${
            isDropdown ? 'px-2' : 'px-4'
          } py-1 border border-green-300 rounded-lg bg-green-100 bg-opacity-75 shadow-sm`}>
          <div className="mr-2">
            <svg
              width={`${isDropdown ? '7' : '14'}`}
              height={`${isDropdown ? '7' : '14'}`}
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7 0C3.13306 0 0 3.13306 0 7C0 10.8669 3.13306 14 7 14C10.8669 14 14 10.8669 14 7C14 3.13306 10.8669 0 7 0ZM7 1.35484C10.119 1.35484 12.6452 3.88105 12.6452 7C12.6452 10.119 10.119 12.6452 7 12.6452C3.88105 12.6452 1.35484 10.119 1.35484 7C1.35484 3.88105 3.88105 1.35484 7 1.35484ZM10.9573 5.03266L10.3222 4.39194C10.1895 4.25927 9.975 4.25927 9.84234 4.38911L5.85121 8.34637L4.16331 6.64435C4.03064 6.51169 3.81613 6.51169 3.68347 6.64153L3.04274 7.27661C2.91008 7.40927 2.91008 7.62379 3.03992 7.75645L5.60282 10.3391C5.73548 10.4718 5.95 10.4718 6.08266 10.3419L10.9544 5.50968C11.0871 5.37702 11.0871 5.1625 10.9573 5.02984V5.03266Z"
                fill="#38A169"
              />
            </svg>
          </div>
          <span
            className={`text-green-500  ${
              isDropdown ? 'font-light text-xs' : 'font-medium'
            }`}>
            Processed {checkedTrips}/{totalTrips}
          </span>
        </div>
      )}
      {(checkedTrips === 0) && (totalTrips > 0) && (
        <div
          className={`flex items-center justify-center ${
            isDropdown ? 'px-2' : 'px-4'
          }  py-1 border border-red-300 rounded-lg bg-red-100 bg-opacity-75 shadow-sm`}>
          <div className="mr-2">
            <svg
              width={`${isDropdown ? '7' : '15'}`}
              height={`${isDropdown ? '7' : '14'}`}
              viewBox="0 0 15 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7.5 0C3.63306 0 0.5 3.13306 0.5 7C0.5 10.8669 3.63306 14 7.5 14C11.3669 14 14.5 10.8669 14.5 7C14.5 3.13306 11.3669 0 7.5 0ZM11.1722 3.32782C13.0181 5.17379 13.148 7.99919 11.7565 9.97782L4.52218 2.74355C6.50363 1.34919 9.32621 1.48185 11.1722 3.32782ZM3.82782 10.6722C1.98185 8.82621 1.85202 6.00081 3.24355 4.02218L10.4778 11.2565C8.49637 12.6508 5.67379 12.5181 3.82782 10.6722Z"
                fill="#FF0000"
              />
            </svg>
          </div>
          <span
            className={`text-red-700  ${
              isDropdown ? 'font-light text-xs' : 'font-medium'
            }`}>
            Unreviewed {checkedTrips}/{totalTrips}
          </span>
        </div>
      )}
    </div>
  );
}

export default SiteProgress;
